module.exports = __webpack_public_path__ + "img/30.Nokiaandroidone.e37bb40c.png";